<div class="row mb-2" *ngIf="(global.globalAgencyId!=null && global.globalAgencyId!=undefined  &&
global.globalAgencyId!=''&& global.globalAgencyId!='00000000-0000-0000-0000-000000000000')">
  <div class="col pl-0">
    <div widget class="card border-0 box-shadow">

      <div class="card-body  widget-body pt-2 pl-0">
        <section id="tabs" class="project-tab">
          <div class="row">

            <div class="col-lg-12">
              <div class="card-header transparent ml-3 border-0">
                <nav>
                  <div class="nav nav-fill pb-2" id="nav-tab" role="tablist">


                    <a class="nav-item nav-link active" id="nav-Utilization-tab" data-bs-toggle="tab"
                      href="#nav-Utilization" role="tab" aria-controls="nav-Utilization" aria-selected="false"
                      (click)="tabchange('Utilization')"
                      [ngClass]="{'mytab-inactive':selecctedTab!='Utilization','active':selecctedTab=='Utilization'}">Utilization
                      Report</a>
                    <a class="nav-item nav-link" id="nav-revenue-tab" data-bs-toggle="tab" href="#nav-revenue"
                      role="tab" aria-controls="nav-revenue" aria-selected="false" (click)="tabchange('RevenueReport')"
                      [ngClass]="{'mytab-inactive':selecctedTab!='RevenueReport','active':selecctedTab=='RevenueReport'}">Revenue
                      Report</a>
                    <a class="nav-item nav-link" id="nav-ClaimChargevsPaid-tab" data-bs-toggle="tab"
                      href="#nav-ClaimChargevsPaid" role="tab" aria-controls="nav-ClaimChargevsPaid"
                      aria-selected="false" (click)="tabchange('ClaimChargevsPaid')"
                      [ngClass]="{'mytab-inactive':selecctedTab!='ClaimChargevsPaid','active':selecctedTab=='ClaimChargevsPaid'}">Claim
                      Charge vs Paid
                      Report</a>
                  </div>
                </nav>
              </div>

              <div class="tab-content" id="nav-tabContent">
                <!-- submission Report -->


                <!--InactiveClient Report-->
                <div class="tab-pane fade  " id="nav-inactiveclient" role="tabpanel"
                  aria-labelledby="nav-inactiveclient-tab"
                  [ngClass]="{'active':selecctedTab=='InactiveClientReport','show':selecctedTab=='InactiveClientReport'}">


                  <div class="row mb-2">
                    <div class="col ml-lg-3">
                      <div widget class="card border-0 box-shadow">
                        <div class="card-header transparent  text-muted">

                          <div class="row">
                            <div class="col-lg-6">
                              <h4 class="mb-0 font-header">Inactive Client Report</h4>
                            </div>
                          </div>
                        </div>

                        <div class="card-body  widget-body pb-0 pt-2 mb-4">
                          <div class="row">
                            <div class="col-lg-6" style="border-right: solid 2px #502189;">
                              <div class="row" *ngFor="let val of Reportfilter;let i=index">
                                <div class="col-lg-5 mb-n2">
                                  <label class="manualentry-label" *ngIf="i==0">Filter
                                    <sup class="super-script">&nbsp;*</sup></label>

                                </div>
                                <div class="col-lg-7">

                                  <input type="radio" value="{{val.Key}}" [(ngModel)]="Report.filter" name="i"
                                    [disabled]="global.globalAgencyId=='00000000-0000-0000-0000-000000000000'"
                                    class="mr-1">{{val.Value}}

                                </div>
                              </div>

                              <div class="row mt-3">
                                <div class="col-lg-5">
                                  <label class="manualentry-label">Start
                                    Date</label>
                                </div>
                                <div class="col-lg-7">

                                  <my-date-picker [options]="myDatePickerOptions" [selDate]="Report.start"
                                    placeholder="mm/dd/yyyy"
                                    (inputFieldChanged)="newdates($event,'inputchage','inactivestart')"
                                    (dateChanged)="newdates($event,'datechagned','inactivestart')"
                                    [disabled]="global.globalAgencyId=='00000000-0000-0000-0000-000000000000'">
                                  </my-date-picker>
                                </div>
                              </div>
                              <div class="row mt-3">
                                <div class="col-lg-5">
                                  <label class="manualentry-label">End
                                    Date</label>
                                </div>
                                <div class="col-lg-7">

                                  <my-date-picker [options]="myDatePickerOptions" [selDate]="Report.end"
                                    placeholder="mm/dd/yyyy"
                                    (inputFieldChanged)="newdates($event,'inputchage','inactiveend')"
                                    (dateChanged)="newdates($event,'datechagned','inactiveend')"
                                    [disabled]="global.globalAgencyId=='00000000-0000-0000-0000-000000000000'">
                                  </my-date-picker>
                                </div>

                              </div>




                              <div class="row mt-3">
                                <div class="col-lg-3">
                                </div>
                                <div class="col">
                                  <button type="button" class="btn btn-sm right"
                                    [disabled]="Report.filter== null||Report.filter==undefined||global.globalAgencyId=='00000000-0000-0000-0000-000000000000' || Report.filter==''"
                                    (click)="showInactiveReport($event)">
                                    Generate Report
                                  </button>
                                </div>

                              </div>
                            </div>

                          </div>
                          <div *ngIf="global.globalAgencyId=='00000000-0000-0000-0000-000000000000'"
                            class="text-center text-danger">
                            <label class="font-red"><i class="fa fa-info-circle fa-lg"></i>&nbsp;Select agency to view
                              details</label>
                          </div>
                        </div>

                      </div>
                    </div>
                  </div>

                </div>
                <!--Spenddown Report-->
                <div class="tab-pane fade  " id="nav-spenddown" role="tabpanel" aria-labelledby="nav-spenddown-tab"
                  [ngClass]="{'active':selecctedTab=='SpenddownReport','show':selecctedTab=='SpenddownReport'}">

                  <div class="row mb-2">
                    <div class="col ml-lg-3">
                      <div widget class="card border-0 box-shadow">
                        <div class="card-header transparent  text-muted">
                          <div class="row">
                            <div class="col-lg-6">
                              <h4 class="mb-0 font-header">SpendDown Report</h4>
                            </div>
                          </div>
                        </div>
                        <div class="card-body  widget-body pb-0 pt-2 mb-4 mt-2">
                          <div class="alert alert-warning" *ngIf="onDOCFileChangedErr!= '' " closable
                            (close)="onDOCFileChangedErr=''">
                            {{onDOCFileChangedErr}}
                          </div>
                          <div class="row no-gutters">
                            <div class="col-lg-2 col-sm-3 col-lg-3 ">
                              Filter
                            </div>
                            <div class="col-lg-6 col-md-6 col-sm-6">
                              <input type="radio" value="All" [(ngModel)]="spendownfilter" name="All"
                                [disabled]="global.globalAgencyId=='00000000-0000-0000-0000-000000000000'"
                                (change)="getspendowndata()">All &nbsp;

                              <input type="radio" value="True" [(ngModel)]="spendownfilter" name="Printed"
                                [disabled]="global.globalAgencyId=='00000000-0000-0000-0000-000000000000'"
                                (change)="getspendowndata()">Printed &nbsp;

                              <input type="radio" value="False" [(ngModel)]="spendownfilter" name="Not Printed"
                                [disabled]="global.globalAgencyId=='00000000-0000-0000-0000-000000000000'"
                                (change)="getspendowndata()">Not
                              Printed &nbsp;
                            </div>
                          </div>
                          <div class="row no-gutters ">
                            <div class="col-lg-12 col-lg-2 text-right">
                              <button (click)="Refresh()" class="btn btn-sm ml-3" style="float: right;">
                                Refresh
                              </button>
                              <button class="btn btn-sm" (click)="showSpendDown($event)">
                                <i class="fa fa-print"></i>
                              </button>
                              <button (click)="MarkSpendDownasPrinted()" *ngIf="spendownfilter=='False'"
                                [disabled]="ParentSpendownId.length==0" class="btn ml-3" style="float: right;">
                                Mark as Printed
                              </button>
                              <button (click)="MarkSpendDownasNotPrinted()" *ngIf="spendownfilter=='True'"
                                [disabled]="ParentSpendownId.length==0" class="btn ml-3" style="float: right;">
                                Mark as Not-Printed
                              </button>
                            </div>
                          </div>
                          <ejs-grid #grid id='grid' [allowResizing]='true' [dataSource]='data | async'
                            (rowSelected)='spendownrowSelected($event)' (checkBoxChange)="spendownselect($event)"
                            allowPaging='true' [allowFiltering]='true' [allowSorting]='true'
                            [pageSettings]='initialPage' [filterSettings]='filterSettings'
                            (dataStateChange)='dataStateChange($event)' [selectionSettings]='selectionOptions'
                            (resizeStop)="onResize($event)" [childGrid]='childGrid'
                            (actionComplete)="onActionComplete($event)" [showColumnChooser]='true'>
                            <e-columns>
                              <e-column type='checkbox' uid="checkbox" maxWidth=50 [showInColumnChooser]='false'>
                              </e-column>
                              <e-column minWidth=100 field="client" headerText="Client Name" type="string"
                                [allowEditing]='false'>
                                <ng-template #filterTemplate let-data>
                                  <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                </ng-template>
                              </e-column>
                              <e-column minWidth=100 field="fromDate" headerText="From Date" type='date'
                                [format]='formatOptions' [allowFiltering]='false'> </e-column>
                              <e-column minWidth=100 field="toDate" headerText="To Date" type='date'
                                [format]='formatOptions' [allowFiltering]='false'>
                              </e-column>
                              <e-column minWidth=100 field="prepareDate" headerText="Prepared Date" type='date'
                                [format]='formatOptions' [allowFiltering]='false'> </e-column>
                              <e-column minWidth=100 field="totalAmount" headerText="Total Amount" type="number"
                                [allowFiltering]='false'>
                                <ng-template #filterTemplate let-data>
                                  <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                </ng-template>
                              </e-column>
                              <e-column minWidth=100 field="claimMasterId" headerText="Claim Id" type="number"
                                [allowFiltering]='false'>
                                <ng-template #filterTemplate let-data>
                                  <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                </ng-template>
                              </e-column>
                              <e-column width="50" [showInColumnChooser]='false'>
                                <ng-template #headerTemplate let-data>
                                  <div>
                                    <span id='show' (click)='show()'><i class="fa fa-cog fa-lg" aria-hidden="true">
                                      </i></span>
                                  </div>
                                </ng-template>
                              </e-column>
                            </e-columns>
                          </ejs-grid>
                          <div *ngIf="SpendownDataList.length == 0" class="text-center" style="color:red">
                            <p>No data available</p>
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>
                  <ng-template #childtemplate let-data>
                    <div>

                      <button class="btnbtn-edit-table" data-bs-target="#SpendDownDetails" data-bs-toggle="modal"
                        (click)="editSpendDown(data.id)" style="height: 24px"><i class="fa fa-edit"></i>
                      </button>
                    </div>
                  </ng-template>
                </div>
                <!--Revenue Report-->
                <div class="tab-pane fade  " id="nav-revenue" role="tabpanel" aria-labelledby="nav-revenue-tab"
                  [ngClass]="{'active':selecctedTab=='RevenueReport','show':selecctedTab=='RevenueReport'}">

                  <div class="row mb-2">
                    <div class="col ml-lg-3">
                      <div widget class="card border-0 box-shadow">
                        <div class="card-header transparent  text-muted">

                          <div class="row">
                            <div class="col-lg-6">
                              <h4 class="mb-0 font-header">Revenue Report</h4>
                            </div>



                          </div>

                        </div>

                        <div class="card-body  widget-body pb-0 pt-2 mb-4">
                          <div class="row">
                            <div class="col-lg-6" style="border-right: solid 2px #502189;">
                              <div class="row">
                                <div class="col-lg-5">
                                  Payor

                                </div>
                                <div class="col-lg-7">
                                  <ng-select [searchable]="true" [clearable]="true" [items]="revenuePayorList"
                                    bindLabel="Value" class="tdropdown" bindValue="Key" [(ngModel)]="selectedPayor">

                                  </ng-select>
                                </div>
                              </div>

                              <div class="row mt-3">
                                <div class="col-lg-5">
                                </div>
                                <div class="col-lg-3">
                                  <input type="radio" value="fromdate" [(ngModel)]="DateFilter" class="me-2"><label>From
                                    Date</label>

                                </div>
                                <div class="col-lg-3">
                                  <input type="radio" value="prepareddate" [(ngModel)]="DateFilter"
                                    class="me-2"><label>Prepared Date</label>

                                </div>

                              </div>
                              <div class="row mt-3">
                                <div class="col-lg-5">
                                  <label class="manualentry-label">Start Date<sup class="super-script">&nbsp;*</sup>
                                  </label>
                                </div>
                                <div class="col-lg-7">

                                  <my-date-picker [options]="Keystatusoption" [selDate]="revenueStart"
                                    placeholder="mm/dd/yyyy"
                                    (inputFieldChanged)="newdates($event,'inputchage','revenuestart')"
                                    (dateChanged)="newdates($event,'datechagned','revenuestart')"
                                    [disabled]="global.globalAgencyId=='00000000-0000-0000-0000-000000000000'">
                                  </my-date-picker>
                                </div>
                              </div>
                              <div class="row mt-3">
                                <div class="col-lg-5">
                                  <label class="manualentry-label">End
                                    Date <sup class="super-script">&nbsp;*</sup></label>
                                </div>
                                <div class="col-lg-7">

                                  <my-date-picker [options]="Keystatusoption" [selDate]="revenueEnd"
                                    placeholder="mm/dd/yyyy"
                                    (inputFieldChanged)="newdates($event,'inputchage','revenueend')"
                                    (dateChanged)="newdates($event,'datechagned','revenueend')"
                                    [disabled]="global.globalAgencyId=='00000000-0000-0000-0000-000000000000'">
                                  </my-date-picker>
                                </div>

                              </div>

                              <div class="row">
                                <div class="col-lg-3"></div>
                                <div class="text-right col">
                                  <button [disabled]="revenueStart==null||revenueStart==undefined||revenueStart==''||revenueEnd==null||revenueEnd==undefined||
                                  revenueEnd=='' " (click)="showrevenue($event)" class="btn btn-sm right">Generate
                                    Report</button>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div *ngIf="global.globalAgencyId=='00000000-0000-0000-0000-000000000000'"
                            class="text-center text-danger">
                            <label class="font-red"><i class="fa fa-info-circle fa-lg"></i>&nbsp;Select agency to view
                              details</label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
                <!-- ClaimChargevsPaid Report -->
                <div class="tab-pane fade  " id="nav-ClaimChargevsPaid" role="tabpanel"
                  aria-labelledby="nav-ClaimChargevsPaid-tab"
                  [ngClass]="{'active':selecctedTab=='ClaimChargevsPaid','show':selecctedTab=='ClaimChargevsPaid'}">
                  <div class="card-body  widget-body pb-0 pt-2 mb-4">

                    <div class="row mb-2">
                      <div class="col ml-lg-3">
                        <div widget class="card border-0 box-shadow">
                          <div class="card-header transparent  text-muted">

                            <div class="row">
                              <div class="col-lg-6">
                                <h4 class="mb-0 font-header">Claim Charge vs Paid Report</h4>
                              </div>
                            </div>
                          </div>
                          <div class="card-body  widget-body pb-0 pt-2 mb-4">
                            <div class="row">
                              <div class="col-lg-6" style="border-right: solid 2px #502189;">
                                <div class="row">
                                  <div class="col-lg-5">
                                    Payor
                                  </div>
                                  <div class="col-lg-7">

                                    <ng-select [searchable]="true" [clearable]="true" [items]="revenuePayorList"
                                      bindLabel="Value" class="tdropdown" bindValue="Key"
                                      [(ngModel)]="selectedClaimPayor">
                                    </ng-select>
                                  </div>
                                </div>
                                <div class="row mt-3">
                                  <div class="col-lg-5">
                                  </div>
                                  <div class="col-lg-3">
                                    <input type="radio" value="fromdate" [(ngModel)]="DateFilterclaim"
                                      class="me-2"><label>From Date</label>

                                  </div>
                                  <div class="col-lg-3">
                                    <input type="radio" value="prepareddate" [(ngModel)]="DateFilterclaim"
                                      class="me-2"><label>Prepared Date</label>

                                  </div>

                                </div>
                                <div class="row mt-3">
                                  <div class="col-lg-5">
                                    <label class="manualentry-label">Start Date<sup class="super-script">&nbsp;*</sup>
                                    </label>
                                  </div>
                                  <div class="col-lg-7">
                                    <my-date-picker [options]="Keystatusoption" [selDate]="ClaimStart"
                                      placeholder="mm/dd/yyyy"
                                      (inputFieldChanged)="newdates($event,'inputchage','claimStart')"
                                      (dateChanged)="newdates($event,'datechagned','claimStart')"
                                      [disabled]="global.globalAgencyId=='00000000-0000-0000-0000-000000000000'">
                                    </my-date-picker>
                                  </div>
                                </div>
                                <div class="row mt-3">
                                  <div class="col-lg-5">
                                    <label class="manualentry-label">End
                                      Date <sup class="super-script">&nbsp;*</sup></label>
                                  </div>
                                  <div class="col-lg-7">
                                    <my-date-picker [options]="Keystatusoption" [selDate]="ClaimEnd"
                                      placeholder="mm/dd/yyyy"
                                      (inputFieldChanged)="newdates($event,'inputchage','claimEnd')"
                                      (dateChanged)="newdates($event,'datechagned','claimEnd')"
                                      [disabled]="global.globalAgencyId=='00000000-0000-0000-0000-000000000000'">
                                    </my-date-picker>
                                  </div>
                                </div>
                                <div class="row mt-3">
                                  <div class="col-lg-3"></div>
                                  <div class="text-right col">
                                    <button [disabled]="ClaimStart==null||ClaimStart==undefined||ClaimStart==''||ClaimEnd==null||ClaimEnd==undefined||
                                  ClaimEnd=='' " (click)="showClaimVsPaid($event)" class="btn btn-sm right">Generate
                                      Report</button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div *ngIf="global.globalAgencyId=='00000000-0000-0000-0000-000000000000'"
                      class="text-center text-danger">
                      <label class="font-red"><i class="fa fa-info-circle fa-lg"></i>&nbsp;Select agency to view
                        details</label>
                    </div>
                  </div>
                </div>
                <!-- Financial Report -->
                <div class="tab-pane fade  " id="nav-Financial" role="tabpanel" aria-labelledby="nav-Financial-tab"
                  [ngClass]="{'active':selecctedTab=='Financial','show':selecctedTab=='Financial'}">




                  <div class="row mb-2">
                    <div class="col ml-lg-3">
                      <div widget class="card border-0 box-shadow">
                        <div class="card-header transparent  text-muted">

                          <div class="row">
                            <div class="col-lg-6">
                              <h4 class="mb-0 font-header">Cheques / EFT Details</h4>
                            </div>



                          </div>

                        </div>

                        <div class="card-body  widget-body pb-0 pt-2 mb-4">
                          <div class="row">
                            <div class="col-lg-6" style="border-right: solid 2px #502189;">

                              <div class="row mt-3">
                                <div class="col-lg-5">
                                  <label class="manualentry-label">Start Date<sup class="super-script">&nbsp;*</sup>
                                  </label>
                                </div>
                                <div class="col-lg-7">
                                  <my-date-picker [options]="Keystatusoption" [selDate]="FinancialStart"
                                    placeholder="mm/dd/yyyy"
                                    (inputFieldChanged)="newdates($event,'inputchage','financialStart')"
                                    (dateChanged)="newdates($event,'datechagned','financialStart')"
                                    [disabled]="global.globalAgencyId=='00000000-0000-0000-0000-000000000000'">
                                  </my-date-picker>
                                </div>
                              </div>
                              <div class="row mt-3">
                                <div class="col-lg-5">
                                  <label class="manualentry-label">End
                                    Date <sup class="super-script">&nbsp;*</sup></label>
                                </div>
                                <div class="col-lg-7">

                                  <my-date-picker [options]="Keystatusoption" [selDate]="FinancialEnd"
                                    placeholder="mm/dd/yyyy"
                                    (inputFieldChanged)="newdates($event,'inputchage','financialEnd')"
                                    (dateChanged)="newdates($event,'datechagned','financialEnd')"
                                    [disabled]="global.globalAgencyId=='00000000-0000-0000-0000-000000000000'">
                                  </my-date-picker>
                                </div>

                              </div>

                              <div class="row">
                                <div class="col text-right">
                                  <button [disabled]="FinancialStart==null||FinancialStart==undefined||FinancialStart==''||FinancialEnd==null||FinancialEnd==undefined||
                              this.FinancialEnd=='' " (click)="showCheckEFT($event)"
                                    class="btn btn-sm right">Download</button>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div *ngIf="global.globalAgencyId=='00000000-0000-0000-0000-000000000000'"
                            class="text-center text-danger">
                            <label class="font-red"><i class="fa fa-info-circle fa-lg"></i>&nbsp;Select agency to view
                              details</label>
                          </div>
                        </div>

                      </div>
                    </div>
                  </div>






                </div>
                <!-- Aging Report -->
                <div class="tab-pane fade  " id="nav-Aging" role="tabpanel" aria-labelledby="nav-Aging-tab"
                  [ngClass]="{'active':selecctedTab=='AgingReport','show':selecctedTab=='AgingReport'}">

                  <div class="row mb-2">
                    <div class="col ml-lg-3">
                      <div widget class="card border-0 box-shadow">
                        <div class="card-header transparent  text-muted">
                          <div class="row">
                            <div class="col-lg-6">
                              <h4 class="mb-0 font-header">Aging Report</h4>
                            </div>
                          </div>
                        </div>
                        <div class="card-body  widget-body pb-0 pt-2 mb-4">
                          <div class="row">
                            <div class="row mt-5 ml-3">
                              <div class="col-lg-0">
                              </div>
                              <div class="col-lg-12">
                                <input type="radio" value="PreparedDate" [(ngModel)]="dateType" name="dateType"
                                  [disabled]="global.globalAgencyId=='00000000-0000-0000-0000-000000000000'">&nbsp;
                                Prepared Date
                              </div>
                            </div>
                            <div class="row mt-5 ml-3">
                              <div class="col-lg-0">
                              </div>
                              <div class="col-lg-12">
                                <input type="radio" value="FromDate" [(ngModel)]="dateType" name="dateType"
                                  [disabled]="global.globalAgencyId=='00000000-0000-0000-0000-000000000000'">&nbsp; From
                                Date
                              </div>
                            </div>
                            <hr>
                            <div class="row mt-5 ml-3">
                              <div class="col-lg-0">
                              </div>
                              <div class="col-lg-12">
                                <input type="radio" value="Yes" [(ngModel)]="locBreak" name="locBreak"
                                  [disabled]="global.globalAgencyId=='00000000-0000-0000-0000-000000000000'">&nbsp; With
                                Location Break
                              </div>
                            </div>
                            <div class="row mt-5 ml-3">
                              <div class="col-lg-0">
                              </div>
                              <div class="col-lg-12">
                                <input type="radio" value="No" [(ngModel)]="locBreak" name="locBreak"
                                  [disabled]="global.globalAgencyId=='00000000-0000-0000-0000-000000000000'">&nbsp;
                                Without Location Break
                              </div>
                            </div>


                            <div class="col-lg-12 mt-3 ml-3">
                              <div class="text-left col">
                                <button (click)="showReportAging($event)" class="btn btn-sm"> Generate
                                  Report</button>
                              </div>
                            </div>

                            <!-- </div> -->
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- Utilization report -->
                <div class="tab-pane fade  " id="nav-Utilization" role="tabpanel" aria-labelledby="nav-Utilization-tab"
                  [ngClass]="{'active':selecctedTab=='Utilization','show':selecctedTab=='Utilization'}">
                  <div class="row mb-2">
                    <div class="col ml-lg-3">
                      <div widget class="card border-0 box-shadow">
                        <div class="card-header transparent  text-muted">
                          <div class="row">
                            <div class="col-lg-6">
                              <h4 class="mb-0 font-header">Utilization Report</h4>
                            </div>
                          </div>
                        </div>

                        <div class="card-body  widget-body pb-0 pt-2 mb-4">
                          <div class="row">
                            <div class="col-lg-6" style="border-right: solid 2px #502189;">

                              <div class="row mb-2">
                                <div class="col-lg-6">
                                  <label>Select Client</label>
                                </div>
                                <div class="col-lg-6">
                                  <ng-select [(ngModel)]="reportClientId" [searchable]="true" [clearable]="true"
                                    [items]="allClientDropDown" bindLabel="clientName"
                                    (ngModelChange)="getAllBudgetsForClient()" bindValue="id">
                                  </ng-select>
                                </div>
                              </div>
                              <div class="row mb-2">
                                <div class="col-lg-6">
                                  <label>Select Budget</label>
                                </div>
                                <div class="col-lg-6">
                                  <ng-select [(ngModel)]="selectedBudgetId" [searchable]="true" [clearable]="true"
                                    [items]="allBudgetDropDown" bindLabel="Value" bindValue="Key">
                                  </ng-select>
                                </div>
                              </div>

                              <div class="row">
                                <div class="col-lg-6">
                                  <label>Report Type</label>
                                </div>
                                <div class="col-lg-6">

  <!-- Row 1 -->
  <div class="d-flex align-items-center gap-3">
    <div>
      <input type="radio"
             [(ngModel)]="ReportType"
             name="reportType"
             value="detail"
             (change)="onDetailSummaryChange('detail')" />
      <label class="ms-1">Detailed</label>
    </div>

    <ng-container *ngIf="ReportType !== 'summary'">
      <div>
        <input type="checkbox"
               [(ngModel)]="isDaily"
               (change)="onDailyChange()" />
        <label class="ms-1">Daily</label>
      </div>

      <div>
        <input type="checkbox"
               [(ngModel)]="isWeekly"
               (change)="onWeeklyChange()" />
        <label class="ms-1">Weekly</label>
      </div>
    </ng-container>
  </div>

  <!-- Row 2 -->
  <div class="mt-2">
    <input type="radio"
           [(ngModel)]="ReportType"
           name="reportType"
           value="summary"
           (change)="onDetailSummaryChange('summary')" />
    <label class="ms-1">Summary</label>
  </div>

</div>
                              </div>




                              <div class="row mt-3">
                                <div class="col-lg-3">
                                </div>
                                <div class="col">
                                  <button type="button" class="btn btn-sm right"
                                    [disabled]="reportClientId == null || reportClientId == undefined || selectedBudgetId == null || selectedBudgetId == undefined"
                                    (click)="showReport()">
                                    Generate Report
                                  </button>
                                </div>

                              </div>
                            </div>

                          </div>
                        </div>

                      </div>
                    </div>
                  </div>





                  <!--  -->


                </div>
              </div>
            </div>
          </div>

        </section>
      </div>
    </div>
  </div>
</div>


<!--select Agency message-->
<div class="row mb-2" *ngIf="(global.globalAgencyId==null ||global.globalAgencyId==undefined ||
global.globalAgencyId=='' || global.globalAgencyId=='00000000-0000-0000-0000-000000000000')
">
  <div class="col pl-0">
    <div widget class="card border-0 box-shadow">
      <div class="card-body pt-2">
        <div class="text-center text-danger pt-3">
          <label class="font-red " style="font-size: 13px;"><i class="fa fa-info-circle fa-lg mr-1"></i>&nbsp;Select
            agency to view details</label>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Open Modal Report//////////////// -->
<span id="openModal3" data-bs-toggle="modal" data-bs-target="#viewReport"></span>
<div class="modal fade" id="viewReport" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
  aria-hidden="true" data-bs-backdrop="static">

  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title font-header">{{reptitle}}</h5>
        <div class="text-right">
          <button class="btn btn-sm mr-2" (click)="closeClaimmodal()">
            Close</button>
        </div>
      </div>
      <div class="modal-body" style="height:600px">
        <ng-container *ngIf="reportcontain == true">
          <div style="width: 100%;height:100%" #reportContainer></div>
        </ng-container>
      </div>
    </div>
  </div>
</div>



<div style="position: absolute; left: -1000px; top: 500px;" *ngIf="batchData!=null">
  <kendo-pdf-export #pdflist paperSize="A4">
    <DIV id="page_1" style="width: 700px;">
      <ng-container *ngFor="let CreatedBatchList of batchData">

        <div class="row pl-0 pr-0">
          <div class="col-lg-10">
            <h5>Submission Report</h5>
          </div>
          <div class="col-lg-2">{{date|date}}</div>
        </div>
        <div class="row pl-0 pr-0">
          <div class="col-lg-12 font-weight-bold">File Name:{{CreatedBatchList?.invoice837P?.file_Name}}</div>
        </div>
        <div class="row pl-0 pr-0">
          <div class="col-lg-12 font-weight-bold">File Creation
            Date:{{CreatedBatchList?.invoice837P?.file_Creation_Date| date:'MM/dd/yyyy'}}</div>
        </div>
        <div class="row pl-0 pr-0">
          <div class="col-lg-12 font-weight-bold">Submission/Control Num:
            {{CreatedBatchList?.invoice837P?.submission_Control_Number}}</div>
        </div>
        <div class="row pl-0 pr-0">
          <div class="col-lg-12 font-weight-bold">
            <h5> {{CreatedBatchList?.invoice837P?.compnay_Name}} </h5>
          </div>
        </div>
        <div class="row pl-0 pr-0">
          <div class="col-lg-1 pr-0 font-weight-bold">
            Claim ID
          </div>
          <div class="col-lg-1 pl-0 pr-0 font-weight-bold">
            From Date
          </div>
          <div class="col-lg-1 pl-1 pr-0 font-weight-bold">
            To Date
          </div>
          <div class="col-lg-1 pl-0 pr-0 font-weight-bold">
            POS
          </div>
          <div class="col-lg-1 pl-0 pr-0 font-weight-bold">
            Procedure
          </div>
          <div class="col-lg-1 pl-0 pr-0 font-weight-bold">
            Modifier
          </div>
          <div class="col-lg-1 pl-0 pr-0 font-weight-bold">
            Rendering
          </div>
          <div class="col-lg-1 pl-0 pr-0 font-weight-bold">
            Last Name
          </div>
          <div class="col-lg-1 pl-1 pr-0 font-weight-bold">
            Units
          </div>
          <div class="col-lg-1 pl-0 pr-0 font-weight-bold">
            Charges
          </div>
          <div class="col-lg-1 pl-0 pr-0 font-weight-bold">
            Net
          </div>
          <div class="col-lg-1 pl-0 pr-0 font-weight-bold">
            Balance
          </div>
        </div>
        <hr
          style="margin-top: 1.5%; border-top: 1px solid rgb(19, 17, 17); width: 100%; box-shadow: 0px 1px 1px #0c0c0c;">

        <ng-container *ngFor="let companyClaim of CreatedBatchList?.invoice837P?.companyClaims">
          <div class="row">
            <div class="col-lg-12">
              <h5>{{companyClaim.companyName}}</h5>
            </div>
          </div>

          <ng-container *ngFor="let val of companyClaim.claimDetail837PInvoice">

            <div class="row pl-0 pr-0">

              <div class="col-lg-4  pr-0 font-weight-bolder">
                {{val?.payor_Name}}
              </div>
              <div class="col-lg-4 pl-0 pr-0 font-weight-bolder">
                {{val?.payor_Id}}
              </div>




            </div>
            <ng-container *ngFor="let val2 of val?.claimDetail">
              <div class="row pl-0 pr-0">

                <div class="col-lg-4  pr-0 font-weight-bolder">
                  {{val2?.client_Last_Name}},&nbsp;{{val2?.client_First_Name}}&nbsp;
                  {{ val2?.client_Middle_Name!=null?val?.client_Middle_Name:''}}
                </div>
                <div class="col-lg-4 pl-0 pr-0 font-weight-bolder">
                  ID:{{val2?.insurence_No}}
                </div>




              </div>
              <ng-container *ngFor="let val1 of val2?.serviceInvoice837P">
                <div class="row  pl-0 pr-0">

                  <div class="col-lg-1">{{val2?.claim_No}}</div>

                  <div class="col-lg-1 pl-0 pr-0">{{val1?.serviceDate| date:'MM/dd/yyyy'}}</div>
                  <div class="col-lg-1 pl-1 pr-0">{{val1?.serviceDate| date:'MM/dd/yyyy'}}</div>
                  <div class="col-lg-1 pl-0 pr-0">{{val1?.service_Location}}</div>
                  <div class="col-lg-1 pl-0 pr-0">{{val1?.service_Code}}</div>
                  <div class="col-lg-1 pl-0 pr-0">{{val?.modifier1}}</div>
                  <div class="col-lg-1 pl-0 pr-0">{{val1?.rendering_Firstname}}</div>
                  <div class="col-lg-1 pl-0 pr-0">{{val1?.rendering_LastName}}</div>
                  <div class="col-lg-1 pl-0 pr-0 text-center">{{val1?.totalUnits}}</div>
                  <div class="col-lg-1 pl-0 pr-0">${{val1?.totalCharges}}</div>
                  <div class="col-lg-1 pl-0 pr-0">${{val1?.totalNetCharges}}</div>
                  <div class="col-lg-1 pl-0 pr-0">${{val1?.totalNetCharges}}</div>
                </div>
              </ng-container>
              <div class="row pl-0 pr-0 mt-2">

                <div class="col-lg-4  pr-0 font-weight-bolder">

                </div>
                <div class="col-lg-4 pl-0 pr-0 font-weight-bolder">

                </div>



                <div class="col-lg-1 pl-0 pr-0 font-weight-bolder text-center">
                  {{val2?.totalUnits}}
                </div>
                <div class="col-lg-1 pl-0 pr-0 font-weight-bolder">
                  ${{val2?.totalCharges}}
                </div>
                <div class="col-lg-1 pl-0 pr-0 font-weight-bolder">
                  ${{val2?.totalNetCharges}}
                </div>
                <div class="col-lg-1 pl-0 pr-0 font-weight-bolder">
                  ${{val2?.totalBalancaCharges}}
                </div>
              </div>
            </ng-container>
          </ng-container>
        </ng-container>

        <hr style="
            margin-top: 1.5%;
            border-top: 1px solid rgb(19, 17, 17);
            width: 100%;
            box-shadow: 0px 1px 1px #0c0c0c;
            ">
        <div class="row">
          <div class="col-lg-6"></div>
          <div class="col-lg-2">Grand Totals:</div>
          <div class="col-lg-1 pl-0 pr-0">{{CreatedBatchList?.invoice837P?.totalUnits}}</div>
          <div class="col-lg-1 pl-0 pr-0">${{CreatedBatchList?.invoice837P?.totalCharges}}</div>

          <div class="col-lg-1 pl-0 pr-0">${{CreatedBatchList?.invoice837P?.totalNetCharges}}</div>

          <div class="col-lg-1 pl-0 pr-0">${{CreatedBatchList?.invoice837P?.totalBalance}}</div>

        </div>
        <hr
          style="margin-top: 1.5%; border-top: 1px solid rgb(19, 17, 17); width: 100%;margin-bottom: 2px; box-shadow: 0px 1px 1px #0c0c0c;">

        <hr style="
          margin-top: 1.5%;
          border-top: 1px solid rgb(19, 17, 17);
          margin-bottom: 6px;
          width: 100%;
          box-shadow: 0px 1px 1px #0c0c0c;
          ">

      </ng-container>
    </DIV>
  </kendo-pdf-export>


</div>





<!-- /////////=======================Exception report=======================================/// -->

<div style="position: absolute; left: -1000px; top: 500px;">
  <kendo-pdf-export #q>
    <div style="width: 700px;" *ngIf="viewFiles">
      <!-- <DIV id="page_1"> -->
      <div>Exception Report</div>
      <ng-container *ngFor="let itembatch of batchDataExceptiondata">

        <div *ngIf="viewFiles">
          <div class="font-weight-bold">Exception Report</div>

          <div class="mt-2">{{itembatch.payorDetail.payorName}}</div>

          <div>{{itembatch.payorDetail.payorStreet}}</div>

          <div>{{itembatch.payorDetail.payorCity}} ,&nbsp;{{itembatch.payorDetail.payorState}}
            &nbsp;{{itembatch.payorDetail.payorZiPCode}}</div>
          <div class="font-weight-bold">PayerID:{{itembatch.payorDetail.payorId}}</div>
          <hr style="
    margin-top: 1.5%;
    border-top: 1px solid rgb(19, 17, 17);
    width: 100%;
    box-shadow: 0px 1px 1px #0c0c0c;
    " />
          <div class="row w-100">
            <div class="col-lg-4">
              <div class="font-weight-bold">{{itembatch.companydetails.companyName}}</div>
              <div class="font-weight-bold">{{itembatch.companydetails.companyAddress}}</div>
              <div class="font-weight-bold">{{itembatch.companydetails.companyCity}}</div>
            </div>
            <div class="col-lg-4">
              <div class="font-weight-bold">Payment Method:&nbsp;&nbsp;{{itembatch?.paymentDetail.payment_Method}}</div>
              <div class="font-weight-bold">Chk/EFT
                date:&nbsp;&nbsp;&nbsp;&nbsp;{{itembatch?.paymentDetail.chk_EFT_date|date:'MM/dd/yyyy'}}</div>
              <div class="font-weight-bold">Remittance Amount:&nbsp;{{itembatch?.paymentDetail.remittance_Amount}}</div>
            </div>
            <div class="col-lg-4">
              <div class="font-weight-bold">Provider#:&nbsp;&nbsp;{{itembatch?.paymentDetail.provider}}</div>
              <div class="font-weight-bold">
                Date:&nbsp;&nbsp;&nbsp;&nbsp;{{itembatch?.paymentDetail.date|date:'MM/dd/yyyy'}}</div>
              <div class="font-weight-bold">Check EFT NBR:&nbsp;{{itembatch?.paymentDetail.check_EFT_NBR}}</div>
            </div>
          </div>
          <hr style="
      margin-top: 1.5%;
      border-top: 1px solid rgb(19, 17, 17);
      width: 100%;
      box-shadow: 0px 1px 1px #0c0c0c;
      " />
          <span class="mt-1"></span>
          <ng-container *ngFor="let val of itembatch.patient_ClaimDetail">
            <hr style="
        margin-top: 1.5%;
        border-top: 1px solid rgb(19, 17, 17);
        width: 100%;
        box-shadow: 0px 1px 1px #0c0c0c;
        " />
            <div class="row w-100">

              <div class="col-lg-2">
                Service Date
              </div>
              <div class="col-lg-1">
                POS
              </div>
              <div class="col-lg-1">
                NOS
              </div>
              <div class="col-lg-1">
                Proc
              </div>
              <div class="col-lg-1">
                MOD
              </div>
              <div class="col-lg-1">
                Billed
              </div>
              <div class="col-lg-2">
                Allowed
              </div>
              <div class="col-lg-1">
                Remark
              </div>

              <div class="col-lg-2">
                Payment
              </div>



            </div>
            <hr style="
        margin-top: 1.5%;
        border-top: 1px solid rgb(19, 17, 17);
        width: 100%;
        box-shadow: 0px 1px 1px #0c0c0c;
        " />
            <div class="row w-100">
              <div class="col-lg-4">
                Patient:{{val?.patient}}
              </div>
              <div class="col-lg-2">
                HIC:{{val?.hic}}
              </div>
            </div>

            <div class="row w-100 mt-1 ">
              <div class="col-lg-2">
                Pat Ctrl #:{{val?.patCtrl}}
              </div>
              <div class="col-lg-5 pr-0">
                Payor Claim Number:{{val?.payor_Claim_Number}}
              </div>
              <div class="col-lg-3 ">
                From Date:{{val?.serviceLineDetail[0]?.serviceDate|date:'MM/dd/yyyy'}}
              </div>
              <div class="col-lg-2 pr-0">
                To Date:{{val?.serviceLineDetail[val.serviceLineDetail.length-1]?.serviceDate|date:'MM/dd/yyyy'}}
              </div>

            </div>
            <ng-container *ngFor="let val1 of val.serviceLineDetail">
              <div class="row w-100">

                <div class="col-lg-2">
                  {{val1?.serviceDate|date:'MM/dd/yyyy'}}
                </div>
                <div class="col-lg-1">

                </div>
                <div class="col-lg-1">
                  {{val?.unit}}
                </div>
                <div class="col-lg-1">
                  {{val1.servicecode}}
                </div>
                <div class="col-lg-1">
                  {{val1?.mod}}
                </div>
                <div class="col-lg-1">
                  {{val1?.billedAmt}}
                </div>
                <div class="col-lg-2 pr-0">
                  {{val1?.notes}}
                </div>
                <div class="col-lg-1">
                  {{val1?.denied_Detail}}
                </div>

                <div class="col-lg-2" style="
          text-align: right;
      ">
                  {{val1?.claimed_Amt}}
                </div>



              </div>
            </ng-container>
            <div class="row w-100">

              <div class="col-lg-3">

                <div class="mt-1"> {{val.patient}}</div>
              </div>

              <div class="col-lg-1">

                <div class="mt-1"> PtResp:</div>
              </div>
              <div class="col-lg-1">
                <div></div>
                <div class="mt-1"> 0.00 </div>
              </div>
              <div class="col-lg-1">

              </div>
              <div class="col-lg-1">
                <hr style="
          margin-top: 1.5%;
          border-top: 1px solid rgb(19, 17, 17);
          width: 100%;
          box-shadow: 0px 1px 1px #0c0c0c;
          " />
                {{val.totalBilledAmt}}
              </div>
              <div class="col-lg-3">

              </div>

              <div class="col-lg-2" style="
        text-align: right;
    ">
                <hr style="
          margin-top: 1.5%;
          border-top: 1px solid rgb(19, 17, 17);
          width: 100%;
          box-shadow: 0px 1px 1px #0c0c0c;
          " />
                {{val.totalClaimAmt}}
              </div>



            </div>
          </ng-container>
          <div class="row">
            <div class="col-lg-4">

            </div>
            <div class="col-lg-1">

            </div>
          </div>
        </div>


      </ng-container>
      <!-- </DIV> -->
    </div>
    <ng-template kendoPDFTemplate let-pageNum="pageNum" let-totalPages="totalPages">
      <div class="kendofooter">
        <hr style="
        margin-top: 1.5%;
        border-top: 1px solid rgb(19, 17, 17);
        width: 100%;
        box-shadow: 0px 1px 1px #0c0c0c;
        " />
        <div> Exception notes: Note 1: The full payment was not made on this service line.</div>
        <div> Note 2: Something has already been paid on this.</div>
        <div> Note 3: The payment amount is less than zero.</div>
        <div> Note 4.This is an old format submit claim id, cannot auto-post</div>
      </div>
    </ng-template>
  </kendo-pdf-export>
</div>
<!--=================================InActive Client Report======================================================-->
<div style="position: absolute; left: -1000px; top: 500px;">
  <kendo-pdf-export #pdfinactive paperSize="A4" margin="0.8cm">
    <div style="width: 730px;">
      <div class="row ">
        <div class="col-lg-10 text-center">
          <h5>Inactive Report</h5>
        </div>
        <div class="col-lg-2 pl-0 pr-0">
          {{today| date:'MM/dd/yyyy'}}
        </div>
      </div><br>
      <div class="row">
        <div class="col-lg-3">
          name
        </div>
        <div class="col-lg-2">
          DOB
        </div>
        <div class="col-lg-2">
          email
        </div>
        <div class="col-lg-2">
          Phone Number
        </div>
        <div class="col-lg-2">
          Intake Date
        </div>

      </div>


      <hr style="
    margin-top: 1.5%;
    border-top: 1px solid rgb(19, 17, 17);
    margin-bottom: 6px;
    width: 100%;
    box-shadow: 0px 1px 1px #0c0c0c;
    ">
      <ng-container *ngFor="let item of InactiveClientReport">



        <div class="row">
          <div class="col-lg-3">
            {{item.name}}
          </div>
          <div class="col-lg-2">
            {{item.dob| date:'MM/dd/yyyy'}}
          </div>
          <div class="col-lg-2">
            {{item.email}}
          </div>
          <div class="col-lg-2">
            {{item.phoneNumber}}
          </div>
          <div class="col-lg-2">
            {{item.intakeDate| date:'MM/dd/yyyy'}}
          </div>

        </div>

      </ng-container>
    </div>
  </kendo-pdf-export>
</div>

<!--================================= spend Down pdf=============================================================================-->
<div style="position: absolute; left: -1000px; top: 500px;">
  <kendo-pdf-export #pdfspendown paperSize="A4" forcePageBreak=".page-break" margin="0.8cm">
    <div style="width: 730px;" id="spendownreport">
      <ng-container *ngFor="let item of Spenddown;let i=index">


        <div class="row w-100">
          <div class="col-lg-8 pr-0">
            <span> {{item.agencyName}} </span> <br />
            <span> {{item.agencyStreet}} </span> <br />
            {{item.agencyCity}}, {{item.agencyState}} {{item.agencyZip}}
          </div>

          <div class="col-lg-4 pl-0">
            <h5 class="font-weight-bold">Invoice</h5>
            <table class="table table-bordered w-75">
              <th style="background-color:white;color:black ;">#Invoice</th>
              <th style="background-color:white;color:black ;">Date</th>
              <tbody>
                <tr>
                  <td>{{"C000"+item.invoiceNumber}} </td>
                  <td> {{item.invoiceDate| date:'MM/dd/yyyy'}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div> <br />

        <div class="row">

          <div class="col-lg-5">
            <table class="table table-bordered">
              <th style="background-color:white;color:black ;">Bill To</th>
              <tbody>
                <td>
                  <span>{{item.billto_Name}}</span><br />
                  <span>{{item.billto_Apt}}</span><br
                    *ngIf="(item?.billto_Apt != undefined) && (item?.billto_Apt != null) && (item?.billto_Apt != '')" />
                  <span>{{item.billto_Street}}</span> <br />
                  {{item.billto_City}}, {{item.billto_State}} {{item.billto_Zipcode}}
                </td>
              </tbody>
            </table>
          </div>

          <div class="col-lg-5">
            <table class="table table-bordered">
              <th style="background-color:white;color:black ;">Client</th>
              <tbody>
                <td>
                  <span>{{item.client}}</span><br />
                  <span>{{item.clientApt}}</span><br
                    *ngIf="(item?.clientApt != undefined) && (item?.clientApt != null) && (item?.clientApt != '')" />
                  <span>{{item.clientAddress}}</span> <br />
                  {{item.clientCity}}, {{item.clientState}} {{item.clientZip}}
                </td>
              </tbody>
            </table>
          </div>

        </div> <br />


        <table style="width: 90%;" class="table table-bordered">
          <th style="width:10% ;background-color:white;color:black ;">Quantity</th>
          <th style=" width:60% ;background-color:white;color:black ;">Description</th>
          <th style=" width:15% ;background-color:white;color:black ;">Rate</th>
          <th style=" width:15% ;background-color:white;color:black ;">Amount</th>
          <tbody>
            <tr style="height: 70%;">
              <td></td>
              <td>
                {{item.description}}
                <br />
                <span class="font-weight-bold">Details:</span> <br />
                <span>{{item.service_Date| date:'MM/dd/yyyy'}} - {{item.service_Date| date:'MM/dd/yyyy'}} -
                  {{item.service}} {{" : "+"$"+item.service_Amount}}</span>
                <br>
                <span>{{item.service_Date| date:'MM/dd/yyyy'}} - {{item.service_Date| date:'MM/dd/yyyy'}} -
                  {{item.service}} {{" : "+"$"+item.adjust_amount}}</span>
              </td>
              <td> {{item.amount}}</td>
              <td> {{item.amount}}</td>
            </tr>
            <tr>
              <td></td>
              <td></td>
              <td>Total</td>
              <td>{{item.amount}}</td>
            </tr>

          </tbody>
        </table>
        <span class="page-break" *ngIf="i!=Spenddown.length-1"></span>
      </ng-container>
    </div>
  </kendo-pdf-export>
</div>


<!--========================================Revenue Report======================================================================-->
<div style="position: absolute; left: -1000px; top: 500px;">
  <kendo-pdf-export #pdfrevenue paperSize="A4" margin="0.8cm">
    <div style="width: 730px;">
      <div class="row w-100">
        <div class="col-lg-8">
          <h5>Filterized on {{filterChargevalue}} From {{revenueStart}} To {{revenueEnd}} </h5>
        </div>
        <div class="col-lg-4 ">
          <span> {{today|date:'EEEE, MMMM d, y'}}</span><br />
          <span> {{today |date:'h:mm:ss a'}}</span>
        </div>
      </div><br>
      <ng-container *ngFor="let Revenue of  locationRevenueBO">
        <div class="row">
          <div class="col-lg-2">
            <label class="font-weight-bold">Location Name:</label>
          </div>
          <div class="col-lg-6">
            <label class="font-weight-bold">{{Revenue.locationName}}</label>
          </div>
        </div>
        <div class="row w-100">
          <div class="col-lg-3">
            <label style="float:left">Payor Name</label>
          </div>
          <div class="col-lg-3" *ngIf="filterChargevalue=='Net'">
            <label style="float:right">Net Charges</label>
          </div>
          <div class="col-lg-3" *ngIf="filterChargevalue=='Gross'">
            <label style="float:right">Gross Charges</label>
          </div>
        </div>
        <hr style="
        margin-top: 1.5%;
        border-top: 1px solid rgb(19, 17, 17);
        width: 100%;
        box-shadow: 0px 1px 1px #0c0c0c;
    " />
        <ng-container *ngFor="let Revenuedetails of Revenue.payorRenvenueInfoDetails">
          <div class="row">
            <div class="col-lg-3">
              <label>{{Revenuedetails.payorName}}</label>
            </div>
            <div class="col-lg-3" *ngIf="filterChargevalue=='Net'">
              <label style="float:right">{{Revenuedetails.netCharges | number:'1.2-2'}}</label>
            </div>
            <div class="col-lg-3" *ngIf="filterChargevalue=='Gross'">
              <label style="float:right">{{Revenuedetails.grossCharges | number:'1.2-2'}}</label>
            </div>

          </div>
        </ng-container>
        <div class="row">
          <div class="col-lg-3">
            <label class="font-weight-bold">Total:</label>
          </div>
          <div class="col-lg-3" *ngIf="filterChargevalue=='Net'">
            <label class="font-weight-bold" style="float:right">{{Revenue.netChargeAmount | number:'1.2-2'}}</label>
          </div>
          <div class="col-lg-3" *ngIf="filterChargevalue=='Gross'">
            <label class="font-weight-bold" style="float:right">{{Revenue.grossChargeAmount | number:'1.2-2'}}</label>
          </div>
        </div>
      </ng-container>

    </div>
  </kendo-pdf-export>
</div>
<!--====================================Claim vs Paid==============================================================-->
<div style="position: absolute; left: -1000px; top: 500px;">
  <kendo-pdf-export #pdfClaimvsPaid paperSize="A4" margin="0.8cm">
    <div style="width: 730px;">
      <div class="row w-100">
        <div class="col-lg-10">
          <h5>Claim versus Paid From {{ClaimStart}} To {{ClaimEnd}} </h5>
        </div>
        <div class="col-lg-2">
          <span> {{today|date:'MM/dd/yyyy'}}</span>
        </div>
      </div><br>

      <ng-container *ngFor="let details of locationClaimvsPaidDetails">
        <div class="row">
          <div class="col-lg-2">
            <label class="font-weight-bold">Location Name:</label>
          </div>
          <div class="col-lg-6">
            <label class="font-weight-bold">{{details.locationName}}</label>
          </div>
        </div>
        <table style="width: 640px;">
          <tr>
            <td><label class="font-weight-bold" style="float:left">Payor Name</label></td>
            <td><label class="font-weight-bold" style="float:right">Charges</label></td>
            <td><label class="font-weight-bold" style="float:right">Paid Amount</label></td>
            <td><label class="font-weight-bold" style="float:right">Percentage</label></td>
          </tr>

          <ng-container *ngFor="let data of details.payorClaimvsPaidDetails">
            <tr>
              <td><label style="float:left">{{data.groupPayorName}}</label></td>
              <td><label style="float:right">{{data.netChargeAmount | number:'1.2-2'}}</label></td>
              <td><label style="float:right">{{data.paidAmount | number:'1.2-2'}}</label></td>
              <td><label style="float:right">{{data.percentage | number:'1.2-2'}}%</label></td>
            </tr>
          </ng-container>
          <tr>
            <td><label class="font-weight-bold">Total:</label></td>
            <td><label style="float:right" class="font-weight-bold">{{details.netChargeAmount | number:'1.2-2'}}</label>
            </td>
            <td><label style="float:right" class="font-weight-bold">{{details.paidAmount | number:'1.2-2'}}</label></td>
            <td><label style="float:right" class="font-weight-bold">{{details.percentage | number:'1.2-2'}}%</label>
            </td>
          </tr>
        </table>
      </ng-container>

    </div>
  </kendo-pdf-export>
</div>
<!--====================================Finance Report==============================================================-->
<div style="position: absolute; left: -1000px; top: 500px;">
  <kendo-pdf-export #Financepdf paperSize="A4" margin="0.8cm">
    <div style="width: 730px;">
      <div class="row w-100">
        <div class="col-lg-9">
          <h5>Track Payment <span style="font-style:11px">Paid From {{FinancialStart}} To {{FinancialEnd}} </span></h5>
        </div>
        <div class="col-lg-3">
          <span> {{today|date:'MM/dd/yyyy'}}</span>
        </div>
      </div><br>


      <div class="row">
        <div class="col-lg-2">
          Ck/EFT Date
        </div>
        <div class="col-lg-2">
          Deposite Date
        </div>
        <div class="col-lg-2">
          Payment Date
        </div>
        <div class="col-lg-3">
          Trace No
        </div>
        <div class="col-lg-3">
          Remitte Amount
        </div>
      </div>
      <hr style="
      margin-top: 1.5%;
      border-top: 1px solid rgb(19, 17, 17);
      margin-bottom: 6px;
      width: 100%;
      box-shadow: 0px 1px 1px #0c0c0c;
      ">
      <!-- <ng-container *ngFor="let item of ClaimvspaidList"> -->
      <ng-container *ngFor="let item of FinancialList">
        <span class="font-weight-bold">Payer: {{item.payor_Name}}</span>
        <ng-container *ngFor="let item1 of item.lPayerTrackPayments">
          <div class="row">
            <div class="col-lg-2">
              {{item1.checkorFFTdate|date:'MM/dd/yyyy'}}
            </div>
            <div class="col-lg-2">
              {{item1.depositDate|date:'MM/dd/yyyy'}}
            </div>
            <div class="col-lg-2">
              {{item1.paymentMethod}}
            </div>
            <div class="col-lg-3">
              {{ item1.traceno}}
            </div>
            <div class="col-lg-3">
              {{item1.remittanceAmt}}
            </div>
          </div>
        </ng-container>
        <div class="row">
          <div class="col-lg-3"></div>
          <div class="col-lg-9">
            <hr style="
          margin-top: 1.5%;
          border-top: 1px solid rgb(19, 17, 17);
          margin-bottom: 6px;
          width: 100%;
          box-shadow: 0px 1px 1px #0c0c0c;
 ">
          </div>
        </div>
        <div class="row">

          <div class="col-lg-4">

          </div>
          <div class="col-lg-5">
            <span>{{item.payor_Name}}</span>

          </div>
          <div class="col-lg-3">
            <span>{{item.totalAmount}}</span>

          </div>


        </div>
      </ng-container>




    </div>
  </kendo-pdf-export>
</div>
<!--====================================Exception Report ERA============================================================-->
<div style="position: absolute; left: -1000px; top: 500px;">
  <kendo-pdf-export #pdflistsample [keepTogether]="keepTogether" paperSize="A4">
    <div style="width: 700px;" *ngIf="viewFiles835">
      <ng-template kendoPDFTemplate let-pageNum="pageNum" let-totalPages="totalPages">

        <div class="kendofooter">
          <div> Exception notes: Note 1: The full payment was not made on this service line.</div>
          <div style="margin-left: 78px;"> Note 2: Something has already been paid on this.</div>
          <div style="margin-left: 78px;">Note 3: The payment amount is less than zero.</div>
          <div style="margin-left: 78px;">Note 4.This is an old format submit claim id, cannot auto-post</div>
        </div>
      </ng-template>

      <div class="font-weight-bold">Exception Report</div>
      <div style="width:700px">
        <ng-container *ngFor="let val of exception835list">
          <div class="row">
            <div class="col-lg-7">
              <div class="row">
                <div class="col-lg-4">
                  <label style="font-weight: 600">File Name:</label>
                </div>
                <div class="col-lg-8">
                  <label>{{val.fileName}}</label>
                </div>
              </div>
            </div>
            <div class="col-lg-5">
              <div class="row">
                <div class="col-lg-5">
                  <label style="font-weight: 600">Imported Date:</label>
                </div>
                <div class="col-lg-7">
                  <label>{{val?.importedDate |date: "MM/dd/yyyy"}}</label>
                </div>
              </div>
            </div>
          </div>
          <hr style="
            margin-top: 1.5%;
            border-top: 1px solid rgb(19, 17, 17);
            width: 100%;
            box-shadow: 0px 1px 1px #0c0c0c;
            " />
          <ng-container *ngFor="let transaction of val.transaction835s">
            <div class="row">
              <div class="col-lg-4">
                <div class="font-weight-bold">{{transaction.payorDetail.payorName}}</div>
                <div class="font-weight-bold">{{transaction.payorDetail.payorStreet}}</div>
                <div class="font-weight-bold">{{transaction.payorDetail.payorCity}} </div>
                <div class="font-weight-bold">
                  {{transaction.payorDetail.payorState}},{{transaction.payorDetail.payorZiPCode}} </div>
              </div>
              <div class="col-lg-4">
                <div class="font-weight-bold">{{transaction.companydetails.companyName}}</div>
                <div class="font-weight-bold">{{transaction.companydetails.companyAddress}}</div>
                <div class="font-weight-bold">{{transaction.companydetails.companyCity}}</div>
                <div class="font-weight-bold">
                  {{transaction.companydetails.companyState}},{{transaction.companydetails.companyZip}}</div>
              </div>
              <div class="col-lg-4">
                <div class="font-weight-bold">Payment Method:{{transaction.paymentDetail.payment_Method}}</div>
                <div class="font-weight-bold">Chk/EFT NBR :{{transaction.paymentDetail.check_EFT_NBR }}</div>
                <div class="font-weight-bold">Check EFT date:{{transaction?.paymentDetail.chk_EFT_date| date:
                  "MM/dd/yyyy"}}</div>
                <div class="font-weight-bold">Remittance Amount:{{transaction.paymentDetail.remittance_Amount}}</div>
              </div>
            </div>
            <ng-container *ngFor="let patientClaim of transaction?.patient_ClaimDetails">
              <hr style="
                margin-top: 1.5%;
                border-top: 1px solid rgb(19, 17, 17);
                width: 100%;
                box-shadow: 0px 1px 1px #0c0c0c;
                " />
              <div class="row w-100">
                <div class="col-lg-2">
                  Service Date
                </div>
                <div class="col-lg-1">
                  POS
                </div>
                <div class="col-lg-1">
                  NOS
                </div>
                <div class="col-lg-1">
                  Proc
                </div>
                <div class="col-lg-1">
                  MOD
                </div>
                <div class="col-lg-1">
                  Billed
                </div>
                <div class="col-lg-2">
                  Allowed
                </div>
                <div class="col-lg-2">
                  Remark
                </div>
                <div class="col-lg-1">
                  Payment
                </div>
              </div>
              <hr style="
                margin-top: 1.5%;
                border-top: 1px solid rgb(19, 17, 17);
                width: 100%;
                box-shadow: 0px 1px 1px #0c0c0c;
                " />
              <div class="row">
                <div class="col-lg-5">
                  <div class="row">
                    <div class="col-lg-4">
                      <label style="font-weight: 600">Patient:</label>
                    </div>
                    <div class="col-lg-8">
                      <label>{{patientClaim.patient}}</label>
                    </div>
                  </div>
                </div>
                <div class="col-lg-3">
                  <div class="row">
                    <div class="col-lg-4">
                      <label style="font-weight: 600">HIC:</label>
                    </div>
                    <div class="col-lg-8">
                      <label>{{patientClaim.hic}}</label>
                    </div>
                  </div>
                </div>
                <div class="col-lg-4">
                  <div class="row">
                    <div class="col-lg-4">
                      <label style="font-weight: 600">Pat Ctrl:</label>
                    </div>
                    <div class="col-lg-8">
                      <label>{{patientClaim.patCtrl}}</label>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-lg-5">
                  <div class="row">
                    <div class="col-lg-6">
                      <label style="font-weight: 600">Payor Claim Number:</label>
                    </div>
                    <div class="col-lg-6">
                      <label>{{patientClaim.payor_Claim_Number}}</label>
                    </div>
                  </div>
                </div>
                <div class="col-lg-4">
                  <div class="row">
                    <div class="col-lg-6">
                      <label style="font-weight: 600">From Date:</label>
                    </div>
                    <div class="col-lg-6">
                      <label>{{patientClaim?.fromDate |date: "MM/dd/yyyy"}}</label>
                    </div>
                  </div>
                </div>
                <div class="col-lg-3">
                  <div class="row">
                    <div class="col-lg-6">
                      <label style="font-weight: 600">To Date:</label>
                    </div>
                    <div class="col-lg-6">
                      <label>{{patientClaim?.toDate |date: "MM/dd/yyyy"}}</label>
                    </div>
                  </div>
                </div>

              </div>

              <ng-container *ngFor="let val1 of patientClaim.serviceLineDetail">
                <div class="row w-100">
                  <div class="col-lg-1">
                    {{val1.serviceDate|date:'MM/dd/yyyy'}}
                  </div>
                  <div class="col-lg-1">

                  </div>
                  <div class="col-lg-1">
                    {{val.unit}}
                  </div>
                  <div class="col-lg-1">
                    {{val1.servicecode}}
                  </div>
                  <div class="col-lg-1">
                    {{val1.mod}}
                  </div>
                  <div class="col-lg-1">
                    {{val1.billedAmt}}
                  </div>
                  <div class="col-lg-2 pr-0">
                    {{val1.notes}}
                  </div>
                  <div class="col-lg-3">
                    {{val1.denied_Detail}}
                  </div>

                  <div class="col-lg-1">
                    {{val1.claimed_Amt}}
                  </div>



                </div>
              </ng-container>
              <br>
              <div class="row w-100">
                <div class="col-lg-3 mt-3">
                  <div class="mt-1">{{patientClaim.patient}}</div>
                </div>
                <div class="col-lg-1 mt-3">
                  <div class="mt-1"> PtResp:</div>
                </div>
                <div class="col-lg-1 mt-3">
                  <div></div>
                  <div class="mt-1"> {{patientClaim.totalPtRespAmt}}</div>
                </div>
                <!-- <div class="col-lg-1">
                  </div> -->
                <div class="col-lg-1 mt-1">
                  <hr style="
                    margin-top: 1.5%;
                    border-top: 1px solid rgb(19, 17, 17);
                    width: 100%;
                    box-shadow: 0px 1px 1px #0c0c0c;
                    " />
                  {{patientClaim.totalBilledAmt}}
                </div>
                <div class="col-lg-5">
                </div>
                <!-- &nbsp; -->
                <div class="col-lg-1 ">
                  <hr style="
                    margin-top: 1.5%;
                    border-top: 1px solid rgb(19, 17, 17);
                    width: 100%;
                    text-align: center;
                    box-shadow: 0px 1px 1px #0c0c0c;
                    " />
                  <div> {{patientClaim.totalClaimAmt}}</div>
                </div>
              </div>
            </ng-container>
          </ng-container>
        </ng-container>
      </div>



    </div>

  </kendo-pdf-export>
</div>




<span id="openReportModal" data-bs-toggle="modal" data-bs-target="#viewReport"></span>
<div class="modal fade " id="viewReport" data-bs-backdrop="static">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title font-header">Utilization Report</h5>
        <div class="text-right">
          <button class="btn blue-btn btn-sm mr-2" (click)="closemodal()">
            Close</button>
        </div>
      </div>
      <div class="modal-body" style="height:600px">
        <ng-container *ngIf="reportcontain== true">
          <div style="width: 100%;height:100%" #reportContainer></div>
        </ng-container>
      </div>
      <div class="modal-footer">

      </div>
    </div>
  </div>
</div>